import { FC } from "react";

import TopNav from "../../components/TopNav/TopNav";
import ContentLayout from "../ContentLayout/ContentLayout";
import { DailyLayoutProps } from "./types";
import ModalResponse from "../../components/ModalResponse/ModalResponse";

import styles from "./DailyLayout.module.css";



const DailyLayout: FC<DailyLayoutProps> = ({ children, title, className, linkBack }) => {
  return (
    <>
      <div className={styles['container']}>
        <TopNav linkBack={linkBack} title={title} />
        <ContentLayout className={className}>
          {children}
          <ModalResponse />
        </ContentLayout>
      </div>
    </>
  );
};

export default DailyLayout;
